module.exports = __webpack_public_path__ + "img/ka.aed7832a.svg";